import React from 'react';
import Reveal from './Reveal';
import { COMPANY } from '../config';

const CTA = () => {
  const scrollTo = (id) => { const el = document.querySelector(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); };

  return (
    <section className="relative py-28 overflow-hidden bg-brand-bg scroll-mt-16">
      {/* Dramatic background */}
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(14,165,233,0.12) 0%, rgba(139,92,246,0.08) 40%, transparent 70%)' }}
      />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal from="up">
          <div className="inline-flex items-center gap-2 glass px-5 py-2 rounded-full text-sm font-medium text-brand-blue border border-brand-blue/20 mb-8">
            <span className="w-2 h-2 rounded-full bg-brand-blue animate-pulse" />
            Ready to Transform Your Business?
          </div>
        </Reveal>

        <Reveal from="up" delay={80}>
          <h2 className="text-5xl md:text-7xl font-black text-brand-text leading-tight mb-6">
            Build the Future<br />
            with <span className="text-gradient">AI</span> Today
          </h2>
        </Reveal>

        <Reveal from="up" delay={140}>
          <p className="text-xl text-brand-muted max-w-3xl mx-auto mb-12 leading-relaxed">
            Join the AI revolution. From intelligent chatbots to full-stack SaaS platforms — let's turn your boldest ideas into production-ready reality.
          </p>
        </Reveal>

        {/* 3 pillars */}
        <Reveal from="up" delay={180}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-14 max-w-4xl mx-auto">
            {[
              { icon: '⚡', title: 'Fast Delivery', desc: 'Proven methodologies to ship your AI solution fast.' },
              { icon: '🧠', title: 'AI-First Mindset', desc: 'Cutting-edge AI tech for real competitive advantage.' },
              { icon: '🤝', title: 'Lifelong Support', desc: 'Ongoing partnership and dedicated support throughout.' },
            ].map((p, i) => (
              <div key={i} className="glass rounded-2xl p-6 border border-brand-border hover:border-brand-blue/30 transition-all duration-300 group">
                <div className="text-3xl mb-3 group-hover:scale-110 transition-transform">{p.icon}</div>
                <h4 className="text-brand-text font-bold mb-2">{p.title}</h4>
                <p className="text-brand-muted text-sm">{p.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>

        {/* Buttons */}
        <Reveal from="up" delay={240}>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
            <button
              onClick={() => scrollTo('#contact')}
              className="btn-primary text-base px-10 py-4 shadow-glow-blue"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
              </svg>
              Contact Us Today
            </button>
            <button
              onClick={() => scrollTo('#products')}
              className="btn-secondary text-base px-10 py-4"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
              Explore Products
            </button>
          </div>
        </Reveal>

        {/* Contact chips */}
        <Reveal from="up" delay={300}>
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 text-brand-muted text-sm">
            <div className="flex items-center gap-2">
              <span className="text-brand-blue">📍</span>
              <span>{COMPANY.LOCATION}</span>
            </div>
            <div className="w-1 h-1 rounded-full bg-brand-dim hidden md:block" />
            <div className="flex items-center gap-2">
              <span className="text-brand-blue">✉️</span>
              <a href={`mailto:${COMPANY.EMAIL}`} className="hover:text-brand-blue transition-colors">{COMPANY.EMAIL}</a>
            </div>
            <div className="w-1 h-1 rounded-full bg-brand-dim hidden md:block" />
            <div className="flex items-center gap-2">
              <span className="text-brand-blue">💼</span>
              <span>Free Consultation Available</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CTA;
